import React from "react";
import Banner from "@/components/Banner";
import { HashLink as Link } from "react-router-hash-link";
import ScrollToTop from "@/components/ScrollTop";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container } from "./styles";

export const Regulation = () => {
	return (
		<React.Fragment>
			<ScrollToTop />
			<Container>
				<Banner
					text='Regulamento'
					img={require("@/assets/img/foto@3x.png").default}
				/>

				<section className='container-fluid'>
					<div className='row justify-content-lg-center'>
						<div className='col-12 col-lg-8'>
							<div className='regulation'>
								<p>
									Antes de efetuar seu cadastro no Programa
									Fidelidade Gerioox, certifique-se de ler
									integralmente os termos e condições
									estabelecidos no Regulamento do mesmo. A sua
									participação e cadastro representam
									concordância e adesão plena e irrestrita aos
									termos e condições estabelecidos no
									Regulamento. Para consultar o Regulamento na
									íntegra: <strong><a href={`${process.env.PUBLIC_URL}/regulamento-programa-fidelidade-gerioox.pdf`} target="_blank" rel="noopener noreferrer">clique aqui.</a></strong> Esperamos que o
									documento abaixo lhe ofereça um guia útil e
									prático para entender melhor os aspectos
									principais do Regulamento acima mencionado.
								</p>
								<ol className='regulation__list'>
									<li>
										<span>1) </span>Para aderir ao Programa
										Fidelidade Gerioox (“Programa”), o
										Cliente deverá realizar sua inscrição
										por meio do site:
										gerioox.com/geriooxfidelidade/ (“Site”),
										onde deverá preencher o formulário de
										cadastro completo, com seus dados e
										informações dos pets que serão incluídos
										no programa.
									</li>
									<li>
										<span>2) </span>Cada Cliente terá o
										direito de incluir até dois pets por
										CPF/cadastro.
									</li>
									<li>
										<span>3) </span>
										Após realizar o cadastro, o Cliente
										poderá acessar o Site ou Plataforma
										através de dispositivos móveis, onde a
										seu critério, terá a opção de
										visualização como um ícone de aplicativo
										na tela deste dispositivo, bastando
										aceitar a notificação na tela inicial.
									</li>
									<li>
										<span>4) </span>
										Em qualquer momento, o Cliente poderá
										acessar todas as informações referentes
										ao seu cadastro, efetuando seu login
										(CPF) e utilizando sua senha, (pessoal e
										intransferível), no Site ou no ícone de
										aplicativo para dispositivos móveis, a
										Plataforma do Programa.
									</li>
									<li>
										<span>5)</span> Todo dia primeiro de
										cada mês, o Cliente terá seu cupom
										disponível para uso. O novo cupom
										disponível poderá ser consultado após
										login no Site ou Plataforma.
									</li>
									<li>
										<span>6) </span> Após realizar a
										inscrição no Programa, o Cliente
										receberá um e-mail de confirmação de
										cadastro, junto de um cupom de
										“boas-vindas”, que também estará
										disponível acessando o seu próprio
										perfil. Esse cupom oferece o direito
										imediato de desconto na primeira compra
										do produto Gerioox 30 (trinta)
										comprimidos, em lojas cadastradas.
									</li>
									<li>
										<span>7) </span>
										Os cupons são codificados e poderão ser
										utilizados uma única vez. Eles são
										intransferíveis, não acumulativos e têm
										validade improrrogável de 30 dias.
									</li>
									<li>
										<span>8) </span>
										Cada cupom será codificado
										individualmente, vinculado diretamente
										ao Cliente, e deverá ser apresentado
										pelo respectivo Cliente, em uma das
										Lojas Participantes do Programa.
										Mediante a apresentação do cupom, por
										dispositivos móveis ou impresso, a Loja
										Participante avaliará os dados do código
										apresentado, como a data do Cupom e
										dados do Cliente. Após essa validação,
										será concedido ao Cliente um desconto
										financeiro de 30% sobre o preço
										praticado pela Loja Participante
										escolhida.
									</li>
									<li>
										<span>9)</span> Caso o Cliente queira
										utilizar o cupom de desconto nas redes
										de E-Commerce participantes do Programa,
										este deverá incluir o código do cupom no
										campo informado, no momento de finalizar
										a compra.
									</li>
									<li>
										<span>10)</span> Para consultar quais
										lojas participam do Programa Fidelidade
										Gerioox:{" "}
										<Link to={`${process.env.PUBLIC_URL}/#stores-participants`}>
											clique aqui
										</Link>{" "}
										e encontre o local mais próximo de você!{" "}
										<br />
										<strong>
											<i>
												*E-commerce e Lojas Físicas
												estabelecidas em todo o
												território nacional.
											</i>
										</strong>
									</li>
									<li>
										<span>11)</span> A Labyes se exime de
										qualquer responsabilidade em relação ao
										preço praticado pela Loja participante
										elegida pelo cliente.
									</li>
									<li>
										<span>12)</span> O Programa poderá ser
										suspenso ou alterado a qualquer momento
										mediante prévia comunicação aos Clientes
										com 30 dias de antecedência, período no
										qual todos os direitos do Cliente
										relativos ao Programa serão mantidos.
									</li>
									<li>
										<span>13)</span> Caso o Cliente não
										deseje mais receber informativos do
										Programa, este poderá se descadastrar ao
										acessar o seu perfil de Cliente no Site
										ou Plataforma, ou ainda mediante
										solicitação para o e-mail{" "}
										<a href='mailto:contato.br@labyes.com'>
											contato.br@labyes.com.
										</a>
									</li>
									<li>
										<span>14)</span> A Labyes se reserva ao
										direito de excluir qualquer Cliente do
										Programa, sem prejuízo das demais
										medidas cabíveis, quando tiver
										conhecimento sobre qualquer conduta
										irregular, eivada de falsidade ou má fé
										empregada pelo mesmo para a utilização
										ou obtenção dos benefícios do Programa.
									</li>
									<li>
										<span>15)</span> É expressamente vedado
										ao Cliente praticar qualquer tipo de
										comercialização dos benefícios obtidos
										por meio do Programa.
									</li>
								</ol>
								<p>
									<strong>
										PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS
									</strong>
								</p>
								<ol className='regulation__list'>
									<li>
										<span>16)</span> A Labyes em regra é a
										controladora de seus dados pessoais e
										adota medidas de razoáveis e cabíveis
										para proteção de dados pessoais.
									</li>
									<li>
										<span>17)</span> O Cliente é responsável
										pela integridade e veracidade das
										informações que forem por ele prestadas
										para a Labyes. O Cliente deverá manter
										todas as informações cadastrais
										completas e devidamente atualizadas sob
										pena de não poder usufruir de todos os
										benefícios oferecidos pelo Programa.
										Assim, pedimos que sempre verifiquem se
										os seus dados pessoais estão corretos e
										atualizados e nos informe caso seja
										necessária alguma correção.
									</li>
									<li>
										<span>18)</span> A Labyes coleta e
										mantém Dados Pessoais diretamente de
										você e de outras fontes publicamente
										disponíveis. Podemos coletar:
										<ul>
											<li>
												a) Nome completo do Cliente;
											</li>
											<li>
												b) Nome e sobrenome do
												responsável e lojista de cada
												Loja Participante;
											</li>
											<li>c) CPF;</li>
											<li>
												d) Dados de login, como usuário
												e senha, assim como os dados
												para confirmação de senha;
											</li>
											<li>e) E-mail;</li>
											<li>
												f) Telefone fixo e/ou celular;
											</li>
											<li>g) Endereço;</li>
											<li>
												h) Nome, espécie e raça, idade
												em anos, peso em quilos do seu
												pet (animal), diagnóstico
												clínico ou motivo para
												utilização do Gerioox e nome do
												médico veterinário responsável.
											</li>
										</ul>
									</li>
									<li>
										<span>19)</span> Os Dados Pessoais
										coletados poderão ser utilizados para
										realizar todos os atos que decorram da
										relação entre você e a Labyes.
									</li>
									<li>
										<span>20)</span> Entendemos que os Dados
										Pessoais que coletamos são necessários e
										servem para propósitos específicos e
										legítimos, assim listamos abaixo as
										situações em que poderemos tratar seus
										Dados Pessoais no contexto da nossa
										relação:
									</li>
								</ol>
								<table>
									<thead>
										<tr>
											<th>Finalidades</th>
											<th>Tipos de Dados Pessoais </th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<strong>
													Cadastrar nossos Clientes no
													Site e Plataforma;
												</strong>
											</td>
											<td>
												Nome completo do Cliente, Nome e
												sobrenome do responsável e
												lojista de cada Loja
												Participante, CPF, senha e dados
												para confirmação de senha,
												e-mail, telefone fixo e/ou
												celular, endereço, nome, espécie
												e raça, idade em anos, peso em
												quilos do seu pet (animal),
												diagnóstico clínico ou motivo
												para utilização do Gerioox e
												nome do médico veterinário.
											</td>
										</tr>
										<tr>
											<td>
												<strong>
													Entregar os serviços
													oferecidos pelo Programa,
													isto é, emitir, enviar e
													validar o Cupom;
												</strong>
											</td>
											<td>
												Nome completo do Cliente, Nome e
												sobrenome do responsável e
												lojista de cada Loja
												Participante, CPF,
												telefone celular.
											</td>
										</tr>
										<tr>
											<td>
												<strong>
													Divulgar benefícios e
													ofertas;
												</strong>
											</td>
											<td>
												Nome completo do Cliente,
												e-mail, telefone celular,
												endereço, nome, espécie e raça,
												idade em anos, peso em quilos do
												seu pet (animal), diagnóstico
												clínico ou motivo para
												utilização do Gerioox.
											</td>
										</tr>
										<tr>
											<td>
												<strong>
													Facilitar a identificação do
													perfil e necessidades dos
													Clientes, a fim de aprimorar
													a oferta de informações e
													ações promocionais;
												</strong>
											</td>
											<td>
												Nome completo do Cliente,
												e-mail, telefone celular,
												endereço, nome, espécie e raça,
												idade em anos, peso em quilos do
												seu pet (animal), diagnóstico
												clínico ou motivo para
												utilização do Gerioox e nome do
												médico veterinário.
											</td>
										</tr>
										<tr>
											<td>
												<strong>
													Enviar informativos sobre
													produtos e/ou serviços de
													interesse aos Clientes;
												</strong>
											</td>
											<td>
												Nome completo do Cliente,
												e-mail, telefone celular,
												endereço, nome, espécie e raça,
												idade em anos, peso em quilos do
												seu pet (animal), diagnóstico
												clínico ou motivo para
												utilização do Gerioox.
											</td>
										</tr>
										<tr>
											<td>
												<strong>
													Divulgar alterações,
													inovações ou promoções sobre
													os produtos e serviços do
													Programa;
												</strong>
											</td>
											<td>
												Nome completo do Cliente,
												e-mail, telefone celular,
												endereço.
											</td>
										</tr>
										<tr>
											<td>
												<strong>
													Enviar newsletters;
												</strong>
											</td>
											<td>
												Nome completo do Cliente,
												e-mail, telefone celular; nome
												do pet (animal).
											</td>
										</tr>
										<tr>
											<td>
												<strong>
													Envio de mensagens na tela
													do celular via Notification
													Push, podendo ser desativado
													a qualquer momento.
												</strong>
											</td>
											<td>
												Nome completo do Cliente, Nome e
												sobrenome do responsável e
												lojista de cada Loja
												Participante, telefone fixo
												celular, nome do pet (animal)
											</td>
										</tr>
									</tbody>
								</table>
								<ol className='regulation__list'>
									<li>
										<span>21)</span> O armazenamento dos
										Dados Pessoais será mantido somente pelo
										período necessário para cumprir a
										finalidade para as quais os Dados
										Pessoais foram coletados, observadas as
										obrigações legais e regulatórias de
										guarda do Labyes.
									</li>
									<li>
										<span>22)</span> Os Dados Pessoais
										coletados referente ao presente
										Regulamento serão automaticamente
										excluídos quando:
										<ul>
											<li>
												a) deixarem de ser úteis aos
												propósitos para os quais foram
												coletadas;{" "}
											</li>
											<li>
												b) da inativação do Cliente por
												mais de 12 (doze) meses;{" "}
											</li>
											<li>
												c) requerido pelo Cliente ou
												interessado e-mail:{" "}
												<a href='mailto:contato.br@labyes.com'>
													contato.br@labyes.com.
												</a>
											</li>
										</ul>
									</li>
									<li>
										<span>23)</span> O regulamento do
										Programa Fidelidade Gerioox na íntegra,
										encontra-se registrado no cartório de
										Valinhos/SP, sob o microfilme 80207.
									</li>
								</ol>
							</div>
						</div>
					</div>
				</section>
			</Container>
		</React.Fragment>
	);
};

export default Regulation;
